import { deleteOwnedMedia, uploadOwnedMedia } from '../../util/ownedMedia';

export async function saveStudioEditorPhotos({
    studio,
    selectedFiles,
    updateStudio,
    uploadMedia = uploadOwnedMedia,
    deleteMedia = deleteOwnedMedia,
}) {
    if (!studio?.id) {
        throw new Error('Studio konnte nicht zugeordnet werden.');
    }

    const photos = Array.isArray(selectedFiles) ? selectedFiles : [];
    const photoKeys = [];
    const uploadedKeys = [];

    try {
        for (const photo of photos) {
            if (photo?.s3Key) {
                photoKeys.push(photo.s3Key);
                continue;
            }

            if (!photo?.file) {
                throw new Error('Foto konnte nicht zugeordnet werden.');
            }

            const uploadResult = await uploadMedia({
                file: photo.file,
                entityType: 'STUDIO',
                entityId: studio.id,
                mediaKind: 'IMAGE',
                slot: 'gallery',
                fileName: photo.file.name || 'studio-photo.jpg',
            });

            uploadedKeys.push(uploadResult.key);
            photoKeys.push(uploadResult.key);
        }

        await updateStudio(studio.id, { images: photoKeys }, studio);

        return {
            photoKeys,
            uploadedKeys,
        };
    } catch (error) {
        if (uploadedKeys.length > 0) {
            const cleanupResults = await Promise.allSettled(
                uploadedKeys.map((key) => deleteMedia({
                    key,
                    entityType: 'STUDIO',
                    entityId: studio.id,
                    mediaKind: 'IMAGE',
                }))
            );
            const failedCleanup = cleanupResults.find((result) => result.status === 'rejected');
            if (failedCleanup) {
                error.cleanupError = failedCleanup.reason;
            }
        }
        throw error;
    }
}
